// helpers
import { makeActionCreator } from '../../../lib/Utils';

export const HEADER_UPDATE_TITLE = 'HEADER_UPDATE_TITLE';
export const updateHeaderTitle = makeActionCreator(HEADER_UPDATE_TITLE, 'title');

export const HEADER_UPDATE_BODY = 'HEADER_UPDATE_BODY';
export const updateHeaderBody = makeActionCreator(HEADER_UPDATE_BODY, 'body');

export const HEADER_UPDATE_ALL = 'HEADER_UPDATE_ALL';
export const updateHeaderAll = makeActionCreator(HEADER_UPDATE_ALL, 'data');
